import React from 'react';

const BottomNav = (props) => {

    return (
        <div id="bottomNavigation">
            {props.children}
        </div>
    );
};

export { BottomNav };